import React, { useState, useMemo } from "react";
import axiosInstance from "../../api/axiosService";
import { useTranslation } from "react-i18next";
import { Input, Select, Space } from "antd";

import "./style.scss"; // We'll define styles separately
// import {
//   RadiusBottomleftOutlined,
//   RadiusBottomrightOutlined,
//   RadiusUpleftOutlined,
//   RadiusUprightOutlined,
// } from "@ant-design/icons";
import { notification } from "antd";

const Context = React.createContext({ name: "Default" });
const { TextArea } = Input;

const ContactForm = () => {
  const { t } = useTranslation();
  const [api, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const openNotification = () => {
    api.success({
      message: "Form Submitted",
      description: "Your contact information has been successfully sent.",
      placement: "topRight",
      duration: 4, // Duration in seconds
    });
  };

  const contactMethod = ["Gmail", "Phone Call", "SMS", "Zalo"];
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    countryCode: "+84",
    phoneNumber: "",
    contactMethod: "email",
    note: "",
  });

  const handleChange = (e) => {
    console.log(e.target, "TARGET");
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);

    // Set loading to true before API call
    setIsLoading(true);

    try {
      await axiosInstance.post("api/mail/send-mail", formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      // Reset form
      setFormData({
        name: "",
        email: "",
        countryCode: "+84",
        phoneNumber: "",
        contactMethod: "email",
        note: "",
      });

      // Show success notification
      openNotification();
    } catch (error) {
      notification.error({
        message: "Submission Failed",
        description: `Error: ${error.message}`,
        placement: "topRight",
      });
    } finally {
      // Set loading to false after API call completes (whether success or error)
      setIsLoading(false);
    }
  };

  // Country codes for the dropdown
  const countryCodes = [
    { code: "+84", country: "Vietnam" },
    // Add more country codes as needed
  ];

  return (
    <div className="form-wrapper">
      {contextHolder}
      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="name">
              {t("Name")}
              <span className="required">*</span>
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group phone-group">
            <label htmlFor="phoneNumber">
              {t("Mobile")} <span className="required">*</span>
            </label>
            <div className="phone-input-container">
              <input
                type="prefix"
                id="phoneNumberPrefix"
                name="phoneNumberPrefix"
                value={countryCodes[0].code}
                className="phone-input-prefix"
                style={{ width: "10%" }}
                required
                disabled
              />
              <input
                type="tel"
                id="phoneNumber"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                className="phone-input"
                required
              />
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="email">
              {t("Email")} <span className="required">*</span>
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group phone-group">
            <label htmlFor="contactMethod">
              {t("ContactMethod")} <span className="required">*</span>
            </label>
            <div className="phone-input-container">
              <Select
                value={formData.contactMethod}
                onChange={(value) => (formData.contactMethod = value)}
                id="contactMethod"
                name="contactMethod"
                style={{ height: "40px" }} // Set explicit height
                className="phone-input"
                required
                options={[
                  { value: "email", label: "Email" },
                  { value: "zalo", label: "Zalo" },
                  { value: "sms", label: "SMS" },
                  { value: "call", label: "Call" },
                ]}
              />
              {/* <input
                id="contactMethod"
                name="contactMethod"
                value={formData.contactMethod}
                onChange={handleChange}
                className="phone-input"
                required
              /> */}
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="note">{t("Note")}</label>
            <TextArea
              id="note"
              name="note"
              value={formData.note}
              onChange={handleChange}
              rows={4}
              placeholder={t("Note")}
            />
          </div>
        </div>

        <div className="form-actions">
          <button type="submit" disabled={isLoading} className="submit-button">
            {isLoading ? t("Sending...") : t("Send")}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ContactForm;
